import {Layout} from '@components/layout/index';
import {LoginForm} from '@components/accounts/v1-forms/FormLogin.jsx';
import {getServerSession} from 'next-auth/next';
import {authOptions} from '../api/auth/[...nextauth]';

export async function getServerSideProps(context) {
  const req = context?.req;
  const res = context?.res;

  const session = await getServerSession(req, res, authOptions(req, res));
  if (session) {
    // console.log('[pages/cartToken][getServerSideProps][session]:', session);
  }

  return {
    props: {
      session,
      showCountdownTimer: false,
      showCountdownTimerMobile: false,
      showGeoTransitBanner: false,
      showFooterSignup: false,
      showFooterSignupMobile: false,
      showEmailSubscriberPopup: false,
      showPushNotificationPopup: false
    }
  };
}

export default function Login() {
  return (
    <div className="py-4">
      <LoginForm />
    </div>
  );
}

Login.Layout = Layout;
